import UserAppContext from "../../hook/UserAppContext"

const Container = ({children}) => {

      const {user} = UserAppContext()

      if(user.length === 0) return

      return (
            <>
            {children}
            </>
      )
}

export default Container;